@reference '../../../../../../styles/tailwind.css';

/* Styles to reset editor */
.tiptap :first-child {
  margin-top: 0;
}

/* Styles to show current selected image */
/* stylelint-disable-next-line selector-class-pattern -- Class provided by ProseMirror. */
.tiptap img.ProseMirror-selectednode {
  @apply outline-2 outline-primary;
}

/* Styles for the editor placeholder and positioning the caret */
.tiptap p.is-editor-empty:first-child::before,
.tiptap p.is-empty::before {
  @apply pointer-events-none float-left h-0 text-muted-foreground;

  content: attr(data-placeholder);
}

/* Styles for mentions */
.tiptap {
  .mention,
  [data-decoration-id] {
    @apply rounded-3xl bg-secondary box-decoration-clone px-2 py-[0.2rem] text-secondary-foreground;
  }

  .node-mention {
    @apply rounded-3xl py-[0.2rem];
  }

  [data-decoration-id] {
    @apply border-b-2 border-dotted border-accent after:content-['\00A0'];
  }
}
